export const GlobalFilterStates = {
  RESET: 'GlobalFilterRESET', // the string value must be unique
  UPDATE: 'GlobalFilterUPDATE',
  UPDATE_FAILED: 'GlobalFilterUPDATE_FAILED',
  UPDATE_SUCCESS: 'GlobalFilterUPDATE_SUCCESS',
};
